export default __webpack_public_path__ + "static/media/seedfund-help.68a5d2f5.svg";